module.exports = __webpack_public_path__ + "static/media/logoptbr.59b7c248.png";